// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1UK2L","alertIcon":"ConfirmModal_alertIcon__DCtpS"};